import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "CHILLNNで料金管理をする方法",
		thumbnailUrl: "/assets/site-controller/reference-articles/chillnn/price-management.jpg",
		url: "https://chillnn.notion.site/3a1a0d9922eb4b8b96030aabf27ad0ca",
	},
];
